import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface MarkersInformation {
    markersInformation: {
        stops: { filtered:Array<any>, noFiltered: Array<any> };
        pois: { filtered:Array<any>, noFiltered: Array<any> };
        stations: { filtered:Array<any>, noFiltered: Array<any> };
        vehicles: Array<any> | null;
    }
    markerRefState:any
}

const initialState : MarkersInformation = {
    markersInformation: {
        stops: { filtered:[], noFiltered:[] },
        pois: { filtered:[], noFiltered:[] },
        stations: { filtered:[], noFiltered:[] },
        vehicles:[]
    },
    markerRefState:null
};

export const markersSlice = createSlice({
    name: 'markersSlice',
    initialState,
    reducers: {
        updateStops: (state, action) => {
            if(action.payload?.filter)
                state.markersInformation.stops.filtered = action.payload?.data;
            else{
                state.markersInformation.stops.noFiltered = action.payload?.data;
                state.markersInformation.stops.filtered = action.payload?.data;
            }
        },
        updatePois: (state, action) => {
            if(action.payload?.filter)
                state.markersInformation.pois.filtered = action.payload?.data;
            else{
                state.markersInformation.pois.noFiltered = action.payload?.data;
                state.markersInformation.pois.filtered = action.payload?.data;
            }
        },
        updateStations: (state, action) => {
            if(action.payload?.filter)
                state.markersInformation.stations.filtered = action.payload?.data;
            else{
                state.markersInformation.stations.noFiltered = action.payload?.data;
                state.markersInformation.stations.filtered = action.payload?.data;
            }
        },
        updateVehicles: (state, action) => {
            state.markersInformation.vehicles = action.payload;
        },
        updateMarkerRef: (state, action) => {
            state.markerRefState = action.payload;
        },
    },
});

export const markersState = (state: RootState) => state.markers.markersInformation;
export const markerRefState = (state: RootState) => state.markers.markerRefState;

export default markersSlice.reducer;
